import { useTheme } from "@emotion/react";
import styled from "@emotion/styled";
import { getLegacyFontStyles } from "pages/Home/HomeStyles";

interface SectionDescriptionProps {
  isMarginBottom?: boolean;
}

export const SectionDescription = styled.p(({ isMarginBottom }: SectionDescriptionProps) => {
  const theme = useTheme();
  const legacySecondaryFontStyle = getLegacyFontStyles(theme).secondary;
  return {
    ...{ legacySecondaryFontStyle },
    maxWidth: "685px",
    color: "#f3f3f3",
    fontSize: "24px",
    fontWeight: 400,
    lineHeight: "120%",
    textAlign: "center",
    margin: "auto",
    marginBottom: isMarginBottom ? "40px" : 0,

    "@media screen and (min-width: 1280px) and (max-width: 1440px)": {
      fontSize: "24px",
      maxWidth: "602px",
    },
    "@media screen and (min-width: 1024px) and (max-width: 1280px)": {
      maxWidth: "451px",
      fontSize: "20px",
    },
    "@media screen and (min-width: 769px) and (max-width: 1024px)": {
      maxWidth: "451px",
      fontSize: "20px",
    },
    "@media screen and (min-width: 390px) and (max-width: 768px)": {
      maxWidth: "451px",
      fontSize: "20px",
    },
    "@media screen and (max-width: 390px)": {
      maxWidth: "85%",
      fontSize: "18px",
    },
  };
});
